import { app, Component, payload, state, v } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import { pageInfo, redirect, sendEvent } from "../../../helpers";
import { PAGES } from "../../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class SignUp extends Component {
	btnId = "signup-submit-btn";
	showPassword = state(false);
	showConfirmPassword = state(false);

	render(...args) {
		pageInfo(PAGES.SIGNUP);

		return h.div(
			{
				class: "min-vh-100 d-flex align-items-center justify-content-center bg-light py-md-5",
			},
			h.div(
				{
					class: "card border-0 shadow-sm p-4 p-md-5",
					style: "max-width: 450px; width: 100%; border-radius: 20px;",
				},

				// Header
				h.div(
					{ class: "text-center mb-4" },
					h.h2(
						{ class: "fw-bold mb-2", style: "color: #010101;" },
						"Create Account"
					),
					h.p(
						{ class: "text-muted small" },
						"Start your Carat Journey"
					)
				),

				// Form
				h.form(
					{ class: "d-grid gap-3" },

					// Google Sign Up
					h.button(
						{
							type: "button",
							class: "btn btn-white btn-lg w-100 d-flex align-items-center justify-content-center gap-2 border shadow-sm",
							style: "border-radius: 12px; background: #fff;",
							onclick: h.func(
								"fireEvent",
								$e.user.needs.googleLogin
							),
						},
						h.img({
							src: "/assets/svg/brands/google.svg",
							alt: "Google",
							style: "width: 24px; height: 24px;",
						}),
						h.span(
							{
								class: "fw-600 text-dark",
								style: "font-size: 0.95rem;",
							},
							"Sign up with Google"
						)
					),

					// Divider
					h.div(
						{ class: "d-flex align-items-center my-2" },
						h.hr({
							class: "flex-grow-1 border-secondary opacity-10",
						}),
						h.span(
							{
								class: "mx-3 text-muted small text-uppercase fw-500",
							},
							"or"
						),
						h.hr({
							class: "flex-grow-1 border-secondary opacity-10",
						})
					),

					// First Name
					h.div(
						{ class: "form-field" },
						h.label(
							{
								for: "first-name",
								class: "form-label fw-600 small text-uppercase text-muted",
							},
							"First Name"
						),
						h.input({
							class: "form-control form-control-lg bg-light border-0",
							type: "text",
							id: "first-name",
							placeholder: "Your first name",
							style: "font-size: 0.95rem;",
						})
					),

					// Last Name
					h.div(
						{ class: "form-field" },
						h.label(
							{
								for: "last-name",
								class: "form-label fw-600 small text-uppercase text-muted",
							},
							"Last Name"
						),
						h.input({
							class: "form-control form-control-lg bg-light border-0",
							type: "text",
							id: "last-name",
							placeholder: "Your last name",
							style: "font-size: 0.95rem;",
						})
					),

					// Email
					h.div(
						{ class: "form-field" },
						h.label(
							{
								for: "email",
								class: "form-label fw-600 small text-uppercase text-muted",
							},
							"Email Address"
						),
						h.input({
							class: "form-control form-control-lg bg-light border-0",
							type: "email",
							id: "email",
							placeholder: "name@example.com",
							style: "font-size: 0.95rem;",
						})
					),

					// Phone
					h.div(
						{ class: "form-field" },
						h.label(
							{
								for: "phone",
								class: "form-label fw-600 small text-uppercase text-muted",
							},
							"Phone Number"
						),
						h.input({
							class: "form-control form-control-lg bg-light border-0",
							type: "tel",
							id: "phone",
							placeholder: "+2547xxxxxxxx",
							style: "font-size: 0.95rem;",
						})
					),

					// Password
					h.div(
						{ class: "form-field" },
						h.label(
							{
								for: "password1",
								class: "form-label fw-600 small text-uppercase text-muted",
							},
							"Password"
						),
						h.div(
							{ class: "input-group" },
							v(
								this.showPassword,
								(visible) =>
									h.input({
										class: "form-control form-control-lg bg-light border-0 d-block",
										type: visible.value
											? "text"
											: "password",
										id: "password1",
										placeholder: "Create a password",
										style: "font-size: 0.95rem; border-top-right-radius: 0; border-bottom-right-radius: 0;",
									}),
								{ $class: "flex-fill" }
							),
							h.button(
								{
									class: "btn btn-light border-0 text-muted",
									type: "button",
									onclick: this.method(
										"togglePasswordVisibility"
									),
									style: "background-color: #f8f9fa; border-top-left-radius: 0; border-bottom-left-radius: 0;",
								},
								v(this.showPassword, (visible) =>
									h.i({
										class: visible.value
											? "fa-solid fa-eye-slash"
											: "fa-solid fa-eye",
									})
								)
							)
						)
					),

					// Confirm Password
					h.div(
						{ class: "form-field" },
						h.label(
							{
								for: "password2",
								class: "form-label fw-600 small text-uppercase text-muted",
							},
							"Confirm Password"
						),
						h.div(
							{ class: "input-group" },
							v(
								this.showConfirmPassword,
								(visible) =>
									h.input({
										class: "form-control form-control-lg bg-light border-0 d-block",
										type: visible.value
											? "text"
											: "password",
										id: "password2",
										placeholder: "Re-enter your password",
										style: "font-size: 0.95rem; border-top-right-radius: 0; border-bottom-right-radius: 0;",
									}),
								{ $class: "flex-fill" }
							),
							h.button(
								{
									class: "btn btn-light border-0 text-muted",
									type: "button",
									onclick: this.method(
										"toggleConfirmPasswordVisibility"
									),
									style: "background-color: #f8f9fa; border-top-left-radius: 0; border-bottom-left-radius: 0;",
								},
								v(this.showConfirmPassword, (visible) =>
									h.i({
										class: visible.value
											? "fa-solid fa-eye-slash"
											: "fa-solid fa-eye",
									})
								)
							)
						)
					),

					// Sign Up Button
					h.button(
						{
							type: "button",
							id: this.btnId,
							class: "btn btn-primary btn-lg w-100 fw-bold text-white mt-2 shadow-sm",
							style: "background: linear-gradient(135deg, #973e87 0%, #b855a4 100%); border: none; border-radius: 12px;",
							onclick: this.method("signUp", ["${this}"]),
						},
						"Create Account"
					)
				),

				// Login Link
				h.div(
					{ class: "text-center mt-4 pt-2" },
					h.span(
						{ class: "text-muted" },
						"Already have an account? "
					),
					h.a(
						{
							href: "#",
							class: "fw-bold text-decoration-none",
							style: "color: #973e87;",
							onclick: "app('router').to('user.login')",
						},
						"Sign In"
					)
				),

				// Back to Home
				h.div(
					{ class: "text-center mt-4" },
					h.a(
						{
							href: "#",
							class: "text-muted small text-decoration-none fw-500",
							onclick: "app('router').to('home')",
						},
						"← Back to Home"
					)
				)
			),
			...args
		);
	}

	togglePasswordVisibility() {
		this.showPassword.value = !this.showPassword.value;
		setTimeout(() => dom.id("password1")?.focus(), 0);
	}

	toggleConfirmPasswordVisibility() {
		this.showConfirmPassword.value = !this.showConfirmPassword.value;
		setTimeout(() => dom.id("password2")?.focus(), 0);
	}

	signUp(button) {
		button.disabled = true;
		const originalText = button.innerText;
		button.innerHTML =
			'<i class="fas fa-spinner fa-spin me-2"></i> Creating account...';
		button.dataset.originalText = originalText;

		let first_name = dom.id("first-name")?.value;
		let last_name = dom.id("last-name")?.value;
		let email = dom.id("email")?.value;
		let phone = dom.id("phone")?.value;
		let password = dom.id("password1")?.value;
		let password_confirmation = dom.id("password2")?.value;

		broker.send(
			$e.user.needs.registration,
			payload(
				{
					first_name,
					last_name,
					email,
					phone,
					password,
					password_confirmation,
				},
				{ id: button.id }
			)
		);
	}

	$$user = {
		authenticated: (ed, event) => {
			if (app("router").is("user.sign-up")) {
				redirect().to("index");
			}
		},

		has: {
			registrationError: (ed, event) => {
				// Re-enable button
				const btn = dom.id(this.btnId);
				if (btn) {
					btn.disabled = false;
					btn.innerText = "Create Account";
				}
			},
		},
	};
}
